/* eslint-disable import/no-anonymous-default-export */
import { exeRequest } from '../utils/APIUtils';

const buildQuery = (params = {}) => {
    const cleaned = Object.entries(params).reduce((acc, [k, v]) => {
        if (v === undefined || v === null || v === '' || (Array.isArray(v) && v.length === 0)) return acc;
        acc[k] = Array.isArray(v) ? v.join(',') : v;
        return acc;
    }, {});
    const qs = new URLSearchParams(cleaned).toString();
    return qs ? `?${qs}` : '';
};

export default {
    getAll: async (params) => exeRequest(`/admin/sinistres${buildQuery(params)}`, "GET"),

    getById: async (id) => exeRequest(`/admin/sinistres/${id}`, "GET"),

    create: async (data) => exeRequest(`/admin/sinistres`, "POST", data),

    update: async (id, data) => exeRequest(`/admin/sinistres/${id}`, "PUT", data),

    delete: async (id) => exeRequest(`/admin/sinistres/${id}`, "DELETE"),

    updateStatut: async (id, data) => exeRequest(`/admin/sinistres/${id}/statut`, "PUT", data),
};
